import React from 'react'
import { TabNav, ShowIf } from '@ztechapps/webui.util'
import { TabName } from './TabName'
import { FromTemplate } from './FromTemplate'
import { FromProject } from './FromProject'
import { FromManualAdd } from './FromManualAdd'
import { useContext } from './Context'

export const Layout = () => {
  const { activeTab, setActiveTab, shownTabs } = useContext()

  return (
    <TabNav tabs={shownTabs} value={activeTab} onChange={setActiveTab}>
      <div className="p-3">
        <ShowIf condition={activeTab === TabName.fromManualAdd}>
          <FromManualAdd />
        </ShowIf>
        <ShowIf condition={activeTab === TabName.fromProject}>
          <FromProject />
        </ShowIf>
        <ShowIf condition={activeTab === TabName.fromTemplate}>
          <FromTemplate />
        </ShowIf>
      </div>
    </TabNav>
  )
}
